import React from 'react'

const SvgComponent = props => (
  <svg width={54} height={54} {...props}>
    <defs>
      <linearGradient
        x1="-12.039%"
        y1="1.214%"
        x2="281.47%"
        y2="203.527%"
        id="network__prefix__a"
      >
        <stop stopColor="#F6B4C2" offset="0%" />
        <stop stopColor="#F6708E" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="-12.039%"
        y1="1.214%"
        x2="155.653%"
        y2="90.79%"
        id="network__prefix__b"
      >
        <stop stopColor="#FBA4B5" offset="0%" />
        <stop stopColor="#E3486A" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <g
        transform="translate(9.643)"
        fill="url(#network__prefix__a)"
        opacity={0.75}
      >
        <circle cx={21.696} cy={11.089} r={11.089} />
        <path d="M14.946 24.107h14.465c8.254 0 14.946 6.692 14.946 14.947V52a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V39.054c0-8.255 6.692-14.947 14.946-14.947z" />
      </g>
      <g fill="url(#network__prefix__b)">
        <circle cx={21.696} cy={11.089} r={11.089} />
        <path d="M14.946 24.107h14.465c8.254 0 14.946 6.692 14.946 14.947V52a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V39.054c0-8.255 6.692-14.947 14.946-14.947z" />
      </g>
    </g>
  </svg>
)

export default SvgComponent
